import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEvent } from "@angular/common/http";
import { SharedService } from './shared.service';
import { Observable } from 'rxjs';
import { AccountService } from './account.service';

@Injectable()
export class GainSightService {

    sfdcData: any = {};
    userInfo: any = {};
    keyUrl = "/svcs/gainsight/key";
    sfdcUrl = "/svcs/gainsight/sfdc";
    userInfoUrl = "/svcs/users/findByUUID"
    httpOptions: object = {
      responseType: 'text'
    };

    constructor(
      private sharedService: SharedService,
      private httpClient: HttpClient,
      private accountService: AccountService) { }

    public async loadScript() {
        const node = document.createElement('script');
        node.type = 'text/javascript';
        node.async = true;
        node.id = 'gainsight';
        node.charset = 'utf-8'
        
        this.sfdcData = await this.getSFDCData();
        const hostname = this.sfdcData.domain;
        this.userInfo = this.sfdcData.user;

        const aprtinsicUserObject = JSON.stringify({
          id: this.userInfo.username + '_' + hostname,
          email: this.userInfo.email,
          firstName: this.userInfo.name.split(0)[0],
          lastName: this.userInfo.name.split(0)[1],
          signUpDate: this.userInfo.dateCreated,
          userType: this.userInfo.type.name,
          portalCode: hostname
        })

        let aptAccountName = '';
        let aptAccountCustomerId = '';
        let aptAccountSFDCId = '';
        if(this.sfdcData.accountId == 1) {
          aptAccountName = "Certain Inc.";
          aptAccountCustomerId = "";
          aptAccountSFDCId = "001U000001PTlT2IAL".toLowerCase();
        } else {
          aptAccountCustomerId = this.sharedService.account.customerId;
          aptAccountSFDCId = this.sfdcData.sfdcId ? this.sfdcData.sfdcId.toLowerCase() : null;
          aptAccountName = await this.getTopLevelAccount(this.sfdcData.accountId);
        }

        // account objects
        const aptrinsicAccountObject = JSON.stringify({
          id: aptAccountSFDCId,
          name: aptAccountName,
          platformAcctId: aptAccountCustomerId,
          sfdcId: aptAccountSFDCId
        })

        this.getAccessKey().subscribe((accessKey: string) => {
          if (accessKey && accessKey.length > 0) {
            const temp = document.createTextNode(`(function(n,t,a,e,co){var i="aptrinsic";n[i]=n[i]||function(){
                (n[i].q=n[i].q||[]).push(arguments)},n[i].p=e;n[i].c=co;
              var r=t.createElement("script");r.async=!0,r.src=a+"?a="+e;
              var c=t.getElementsByTagName("script")[0];c.parentNode.insertBefore(r,c)
            })(window,document,"https://web-sdk.aptrinsic.com/api/aptrinsic.js","${accessKey}")

            //passing user and account objects:
            aptrinsic("identify",
              ${aprtinsicUserObject},
              ${aptrinsicAccountObject});
            
            aptrinsic('bot', 'search', {labels: ['gainsight_article']});
            `);
            node.appendChild(temp);
            document.getElementsByTagName('head')[0].appendChild(node);
          }
        });
    }

    getAccessKey(): Observable<string> {
      return this.httpClient.get<any>(this.keyUrl, this.httpOptions);
    }

    /* async getUserInfo(accountId, userUUID) {
      let url = this.userInfoUrl;

      return await this.httpClient.get(url + "?accountId=" + accountId + '&uuid=' + userUUID , {
          observe: "response",
          headers: this.sharedService.headers
      }).toPromise();
    } */

    async getSFDCData(accountId?: number | string) {
      let url = this.sfdcUrl;
      if (accountId) {
        url += `?accountId=${accountId}`;
      }
      const resp = await this.httpClient.get<any>(this.sfdcUrl, this.httpOptions).toPromise();
      return JSON.parse(resp);
    }

    async getHierarchy() {
      const resp: any = this.accountService.getHierarchy(1, 1, '').toPromise();
      return (await resp).body.accountHierarchyList;
    }

    async getTopLevelAccount(userAccountId) {
      let topLevelAccount = this.sharedService.account.name;
      let accountData;
      const hierarchy = await this.getHierarchy();
      if (hierarchy?.length > 0) {
        for (let account of hierarchy) {
          if (account.id == userAccountId) {
            accountData = account;
            break;
          }
        }
        const ids = accountData.idPath.slice(0, -1).split(',');
        const accounts = accountData.path.slice(0, -1).split('>');
        if (ids[0] == "1") {
          if (ids.length > 1) {
            topLevelAccount = accounts[1];
          } 
        } else {
          topLevelAccount = accounts[0];
        }
      }
      return topLevelAccount;
    }
}
